import { TrackBox } from "@opendaw/studio-boxes";
import { Attempts, clamp } from "@opendaw/lib-std";
import { RegionOverlap } from "./timeline/RegionOverlap";
import { TempoRange } from "./TempoRange";
import { BaseFrequencyRange } from "./BaseFrequencyRange";
export var Validator;
(function (Validator) {
    Validator.isTimeSignatureValid = (numerator, denominator) => {
        if (!Number.isInteger(numerator) || numerator < 1 || numerator > 31) {
            return Attempts.err("Numerator needs to be a interger between 1 and 31");
        }
        if (!Number.isInteger(denominator) || denominator < 1 || denominator > 32 || (denominator & (denominator - 1)) !== 0) {
            return Attempts.err("Denominator must be a power of two between 1 and 32");
        }
        return Attempts.ok([numerator, denominator]);
    };
    Validator.clampBpm = (bpm) => Number.isFinite(bpm)
        ? clamp(bpm, TempoRange.min, TempoRange.max)
        : TempoRange.default;
    Validator.clampBaseFrequency = (hz) => Number.isFinite(hz)
        ? clamp(hz, BaseFrequencyRange.min, BaseFrequencyRange.max)
        : BaseFrequencyRange.default;
    Validator.hasOverlappingRegions = (boxGraph) => boxGraph.boxes()
        .some(box => box instanceof TrackBox && RegionOverlap.find(RegionOverlap.sortedRegions(box)).nonEmpty());
})(Validator || (Validator = {}));
